import React from 'react';
import {HeroSection} from '../components/HeroSection';
import {ServicesSection} from '../components/ServicesSection';
import {AdBlockBanner} from '../components/AdBlockBanner';
import {WhyUsSection} from '../components/WhyUsSection';
import {CooperationSection} from '../components/CooperationSection';
import {PricingSection} from '../components/PricingSection';
import {CameraCalculator} from '../components/CameraCalculator';
import {FAQSection} from '../components/FAQSection';
import {ContactSection} from '../components/ContactSection';
import {useSeo} from '../hooks/useSeo';

export function HomePage() {
    useSeo({
        title: 'Kamery i Monitoring Mielec (39-300) - Montaż CCTV, Alarmy, Anty-reklama Wi-Fi | kamerymielec.pl',
        description:
            'Profesjonalny montaż kamer i monitoringu CCTV w Mielcu oraz w promieniu do 250 km (Rzeszów, Tarnów, Dębica, Stalowa Wola, Tarnobrzeg, Kolbuszowa, Połaniec, Sandomierz, Kraków, Kielce). Systemy alarmowe, anty-reklama na domowe Wi-Fi, domofony i sieci IT. Bezpłatna wycena, szybki montaż w 24-48h, gwarancja.',
        canonicalPath: '/',
        keywords:
            'monitoring Mielec, kamery Mielec, montaż kamer Mielec, monitoring mielec i okolice, kamery do 250 km, montaż monitoringu Mielec, CCTV Mielec, monitoring Rzeszów, kamery Dębica, monitoring Tarnów, kamery Stalowa Wola, monitoring Tarnobrzeg, kamery Kolbuszowa, monitoring Sandomierz, monitoring domu Mielec, monitoring firmy Mielec, anty-reklama wifi mielec, blokada reklam wifi dom, kalkulator monitoringu, kamery 4k mielec, podgląd kamer telefon',
        breadcrumbs: [{name: 'Strona główna', path: '/'}],
    });

    return (
        <>
            <HeroSection/>
            <ServicesSection/>
            <AdBlockBanner/>
            <WhyUsSection/>
            <CooperationSection/>
            <PricingSection/>
            <CameraCalculator/>
            <FAQSection/>
            <ContactSection/>
        </>
    );
}
